var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2734)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6279 0 24 5.37212 24 12C24 18.6279 18.6279 24 12 24C5.37212 24 0 18.6279 0 12C0 5.37212 5.37212 0 12 0ZM6.59522 12L6.60387 15.1731L9.30002 16.7596V18.6173L5.02599 16.1106V11.0721L6.59522 12ZM6.59522 8.82693V10.676L5.02502 9.74712V7.89808L6.59522 6.96924L8.1731 7.89808L6.59522 8.82693ZM10.426 7.89808L11.9962 6.96924L13.5741 7.89808L11.9962 8.82693L10.426 7.89808ZM9.29999 13.5865L7.7298 12.6577V14.5154L9.29999 15.4356V13.5865ZM11.9961 18.3539L10.426 17.425V19.274L11.9961 20.2029L13.574 19.274V17.425L11.9961 18.3539ZM17.3961 6.96924L15.826 7.89808L17.3961 8.82693V10.676L18.974 9.74712V7.89808L17.3961 6.96924ZM18.975 11.0712L17.4048 12L17.3961 15.1731L14.701 16.7587V18.6164L18.975 16.1096V11.0712ZM16.2702 14.5154L14.7 15.4356V13.5866L16.2702 12.6577V14.5154ZM16.2788 11.3423L16.2702 9.48462H16.2769L14.699 8.55577L11.9952 10.15L9.30768 8.55577L7.73076 9.48462V11.3423L10.4346 12.9289V16.1096L12.0048 17.0298L13.575 16.1096V12.9289L16.2788 11.3423ZM11.9961 3.79712L7.7298 6.3125L9.29999 7.24135L11.9961 5.64712L14.7 7.24135L16.2702 6.3125L11.9961 3.79712Z",
    fill: "#DAA636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.2ca4d0a29975a8421c567b7d4ea483da.svg";
export { ForwardRef as ReactComponent };